
import Button from '@/components/NewUiElements/Buttons/Button'
import FoldersMixin from '@/mixins/Folders/FoldersMixin'
import FilesystemNodeIcon from '@/components/Folders/FilesystemNodeIcon'

export default {
    name: 'MoveNodeModal',
    components: { FilesystemNodeIcon, Button },
    mixins: [FoldersMixin],
    props: {
        node: {
            type: Object,
            default: null
        },
        parent: {
            type: Object,
            required: false,
            default: null
        },
        browse: {
            type: [Boolean, null],
            default: null
        },
        create: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            nodes: [],
            folder: null,
            target: null,
            loading: false,
            page: 1,
            pagination: null,
            isCreatingNewFolder: false,
            newFolderName: '',
            newNodeName: ''
        }
    },
    computed: {
        invalidTarget () {
            return !this.target?.id ||
                (this.target === this.folder && this.nodes.find(n => n.node_type === this.node?.node_type && n.name === this.nodeName) !== undefined) /* ||
                (this.parent !== null && this.target?.id === this.parent?.id) */
        },
        invalidNewFolder () {
            return this.nodes.find(n => n.name === this.newFolderName) !== undefined
        },
        nodeName () {
            return this.name ? this.newNodeName : this.node?.name
        }
    },
    watch: {
        isCreatingNewFolder (value) {
            if (value) {
                setTimeout(() => this.$refs.newFolder.focus(), 100)
            }
            if (!value && this.folder?.id) {
                this.createNewFolder()
            }
            this.newFolderName = ''
        }
    },
    mounted () {
        this.folder = this.parent
        this.newNodeName = this.name
        this.list(this.folder?.id)
    },
    methods: {
        list (id, page = 1) {
            this.loading = true
            if (page === 1) {
                this.page = 1
            }

            const params = {
                sort_by: 'name',
                sort_as: 'asc',
                extra: ['is_empty'],
                dialog: true,
                page
            }

            this.listNodes(id, params)
                .then(({ data }) => {
                    this.folder = data?.folder
                    this.target = this.folder
                    this.pagination = data.meta

                    if (page > 1) {
                        for (const node of data.data) {
                            this.nodes.push(node)
                        }
                    } else {
                        this.nodes = data.data
                    }
                })
                .catch((e) => {
                    throw e
                })
                .finally(() => {
                    this.loading = false
                })
        },
        moveNode () {
            if (this.invalidTarget) { return }
            const data = {
                target: this.target
            }
            if (this.name) {
                data.name = this.newNodeName
            }

            this.$emit('move-node', data)
        },
        loadMore () {
            this.loading = true
            this.page++
            this.list(this.target.id, this.page)
        },
        toggleTarget (fsNode) {
            if (this.target === fsNode) {
                this.target = this.folder
            } else {
                this.target = fsNode
            }
        },
        isInvalidNodeTarget (node) {
            const isInMyFoldersPage = this.$router.currentRoute.name === 'Folders-hash'

            return this.node?.id === node.id ||
                (isInMyFoldersPage && this.$store.getters['folders/selectedNodes'].includes(node.id))
        },
        async createNewFolder () {
            if (this.loading || !this.newFolderName || !this.folder?.id || this.invalidNewFolder) {
                return
            }
            this.loading = true
            this.isCreatingNewFolder = false
            await this.createFolder(this.newFolderName, this.folder.id)
                .then(({ data }) => {
                    this.$emit('refresh')
                    this.list(data?.id)
                })
                .catch((e) => {
                    this.$toast.error(this.$t('حصل خطأ'))
                })
                .finally(() => {
                    this.loading = false
                })
            // this.list(this.folder?.id)
        }
    }
}
